var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var TabsBlocks = /** @class */ (function (_super) {
    __extends(TabsBlocks, _super);
    function TabsBlocks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabsBlocks.prototype.render = function () {
        return (React.createElement("sb-tabs-blocks", { "data-tabs-wrapper": true }, this.props.children));
    };
    return TabsBlocks;
}(React.Component));
export { TabsBlocks };
//# sourceMappingURL=TabsBlocks.js.map